module.exports = __webpack_public_path__ + "img/cases-part1-1.370f3834.png";